export default __webpack_public_path__ + "static/Dymowski-a31c210aa1cea4814da0a520646741a4.jpeg";